import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import { Box } from "@mui/material";

import UsingAiHelp from "../../assets/UsingAiHelpLight.png";

export default function DataPrivate({ scrollToBottom, lessThanXL }) {
  return (
    <Box
      sx={{
        paddingLeft: !lessThanXL ? "70px" : "21px",
        paddingRight: !lessThanXL ? "70px" : "21px",
      }}
    >
      <Grid container>
        <Grid item md={12}>
          <Box
            sx={{
              borderRadius: "16px",
              paddingTop: !lessThanXL ? "10px" : "80px",
              paddingBottom: !lessThanXL ? "10px" : "80px",
            }}
          >
            <Grid container alignItems="center">
              {!lessThanXL ? (
                <Grid mt={5} item sm={12} md={5} sx={{ textAlign: "center" }}>
                  <img
                    loading="lazy"
                    height={"580px"}
                    width={"500px"}
                    src={UsingAiHelp}
                    alt="Person writing on a laptop talking to AI assistant"
                  />
                </Grid>
              ) : (
                ""
              )}
              <Grid item md={1}></Grid>
              <Grid item sm={12} md={6}>
                <Typography
                  fontWeight="700"
                  component="span"
                  sx={{
                    paddingRight: "10px",
                    fontSize: !lessThanXL ? "34px" : "32px",
                    fontStyle: !lessThanXL ? "italic" : "",
                    background: (theme) => theme.palette.gradient.toTop,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    lineHeight: "normal",
                  }}
                >
                  Turn complex documents into clear answers
                </Typography>
                <Typography
                  sx={{
                    color: "#1F1F1F",
                    fontSize: !lessThanXL ? "34px" : "32px",
                  }}
                  component="span"
                  lineHeight={"normal"}
                  fontWeight="700"
                  gutterBottom
                >
                  - while keeping sensitive data private
                </Typography>
                {!lessThanXL ? (
                  ""
                ) : (
                  <Grid
                    mt={5}
                    mb={5}
                    item
                    sm={12}
                    md={6}
                    sx={{ textAlign: "center" }}
                  >
                    <img
                      loading="lazy"
                      height="250px"
                      src={UsingAiHelp}
                      alt="Person writing on a laptop talking to AI assistant"
                    />
                  </Grid>
                )}
                <Typography
                  fontSize="18px"
                  fontWeight={"400"}
                  color="#393939"
                  variant="body1"
                  mb={3}
                  mt={3}
                >
                  Dokusense is your AI-powered assistant for working with
                  complex PDF documents. Built on cutting-edge
                  Retrieval-Augmented Generation (RAG), our system delivers
                  fast, accurate insights - and takes your data privacy to the
                  next level with built-in anonymization of personal and
                  sensitive information.
                </Typography>
                <Button
                  onClick={scrollToBottom}
                  variant="contained"
                  aria-label="Request acces to DokuSense"
                  sx={{ backgroundColor: "#466A88", borderRadius: "8px" }}
                >
                  Request access
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
